<h1>Observar</h1>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="controls">
        <app-input formControlName="riskComment" [default]="data?.riskComment" autocomplete="off" type="text" label="Comentario"></app-input>
    </div>

    <input type="submit" class="button button-dark-blue" value="Confirmar" />
    <input type="button" class="button button-gray" value="Cancelar" (click)="cancel()" />
</form>
